//====================================================
//  Function: Base Settings
//  - uloženie základných vlastnosti/stavov šablony do premenných pre znovupoužitelnosť v rámci kodu.
//====================================================
var shopDataLayerData;
var isSidePanel;
var isDesktop;
var isMobile;

function baseSettings() {
  shopDataLayerData = dataLayer[0].shoptet;
  registeredCustomer = shopDataLayerData.customer.registered;

  isSidePanel = $("body.multiple-columns-body").length > 0 ? true : false;
  isDesktop = $("body.desktop").length > 0 ? true : false;
  isMobile = $("body.mobile").length > 0 ? true : false;

  $("body").addClass("wilsondo");

  if (registeredCustomer) {
    $("body").addClass("is-logged");
  }
}
